<template>
    <div>
        <template v-if="expense_categories_crud == true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Edit Expense Category</h1>
            </div>
            <div class="company-main">
                <form @submit.prevent="editExpenseCategory">
                    <div class="tab-content-inner">
                        <template>
                            <div class="people-management-inner-content p-5">
                                
                                <div class="user-permissions">
                                    <div class="form-group">
                                        <label>Name</label>
                                        <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" />
                                        <has-error :form="form" field="username"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label> Status </label>
                                        <select v-model="form.status" name="status" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('status') }">
                                            <option value="">Select Status</option>
                                            <option value="ACTIVE" :selected="form.status == 'ACTIVE' ? 'selected' : ''">ACTIVE</option>
                                            <option value="INACTIVE" :selected="form.status == 'INACTIVE' ? 'selected' : ''">INACTIVE</option>
                                        </select>
                                        <has-error :form="form" field="status"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                        <router-link to="/expenseCategories" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                                    </div>
                                </div>

                            </div>
                        </template>
                    </div>

                </form>
            </div>
        </template>
        <template v-if="expense_categories_crud == null">
            <preLoader></preLoader>
        </template>
        <template v-if="expense_categories_crud == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form : new Form({
                    id: '',
                    name: '',
                    status:''
                }),
                expense_categories_crud : null,
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('expense_categories_crud').then(result => {
                this.expense_categories_crud = result.expense_categories_crud;
                this.$Progress.finish();
                this.getExpenseCategoryData();
            });
        },
        
        methods: {
            editExpenseCategory() {
                this.$Progress.start();
                if(this.form.name == ''){
                    this.showAlertBox('error', 'Name field is required');
                    this.$Progress.finish();
                    return false;
                }
                this.form.put('/api/eMoney/updateExpenseCategory')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        if(res.data.data == "Duplicate"){
                            this.showToastBox('error', 'Category already added please use different category name!');
                        }else{
                            this.showToastBox('success', 'Category updated successfully');
                            this.$router.push('/expenseCategories');
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error', 'Some problem in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Some problem in your form data');
                });
            },

            getExpenseCategoryData(){
                this.$Progress.start();
                axios.get('/api/eMoney/editExpenseCategory/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.name = res.data.category_title;
                        this.form.status = res.data.expense_status;
                        this.form.id = res.data.id;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error', 'Some problem in your form data');
                    }
                }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Some problem in your form data');
                });
            }
        }
    }
</script>
